import {SuccessfulApiResponse} from "@eryxcoop/appyx-comm";

export default class PaymentTermsResponse extends SuccessfulApiResponse {
    static defaultResponse() {
        return {
            object:
                [
                    {
                        'code': "30C",
                        'description' : "30 days net",
                        'days': "15"
                    },
                    {
                        'code': "20C",
                        'description' : "45 days net",
                        'days': "10"
                    },
                ],
            errors: []
        }
    }

    paymentTerms() {
        const paymentTerms = this.content()
        return paymentTerms.map(payment_term => {
            return {
                code: payment_term.code,
                description: payment_term.description,
                days: payment_term.days,
            }
        })
    }
}